import { render, staticRenderFns } from "./StoreFloatBtns.vue?vue&type=template&id=9b2c4df8&"
import script from "./StoreFloatBtns.vue?vue&type=script&lang=js&"
export * from "./StoreFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports